import axios from "axios";

const getToken = () => {
  let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : localStorage.getItem('token');
  let refresh = sessionStorage.getItem('refresh') ? sessionStorage.getItem('refresh') : localStorage.getItem('refresh');
  return { token, refresh }
}


const axiosClientUploadFormData = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    "content-type": "multipart/form-data",
    // "X-Forwarded-For": `${sessionStorage.getItem("ip")}`,
    authorization: `vinorsoft ${getToken().token}`,
  },
});
//"application/json"
// axios.defaults.headers = {
//   'Cache-Control': 'no-cache',
//   'Pragma': 'no-cache',
//   'Expires': '0',
// };
axiosClientUploadFormData.interceptors.request.use(async (config) => {
  return config;
});
axiosClientUploadFormData.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  (error) => {
    if (getToken().token && error?.response?.status === 401) {
      // // console.log(getToken().refresh, getToken().token);
      async function refreshToken() {
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}authenticator/refreshToken/`,
            {
              refresh: getToken().refresh,
            },
            {
              headers: {
                "Content-Type": "application/json",
                // "X-Forwarded-For": `${sessionStorage.getItem("ip")}`,
              },
            }
          );
          sessionStorage.setItem("token", res.data.access);
          localStorage.setItem("token", res.data.access);
          // // console.log('done set token');
          // sessionStorage.setItem("token", res.data.access);
          window.location.reload()
        } catch (error) {
          if (error?.response?.status === 401) {
            // // console.log(getToken());
            window.location.replace('/login')
          }
        }
      }
      refreshToken();
    }
    throw error;
  }
);
export default axiosClientUploadFormData;
